import React, { Suspense, useMemo, useState, useEffect, useRef } from 'react'
import Oval from 'react-loading-icons/dist/esm/components/oval';
import { useDispatch, useSelector } from 'react-redux';
import { Await, defer, useLoaderData, useNavigate } from 'react-router-dom';
import { addSitesToGroup, enableUserNotifications, getCompanyUserList, getGroups, getUsersDevices, removeUser, switchInstallerMode } from '../../Api Methods/Api';
import DevicesGrid from '../../components/GridList/DevicesGrid';
import FilterUsersDeviceSearch from '../../components/PowerSearch/FilterUsersDeviceSearch';
import ActivityTableLayout from '../../components/Table/ActivityTableLayout';
import PortalUsersTableLayout from '../../components/Table/PortalUsersTableLayout';
import UserDevicesTableLayout from '../../components/Table/UserDevicesTableLayout';
import SearchBar from '../SearchView/Search/SearchBar';
import PortalActivityPage from '../PortalActivity/PortalActivityPage';
import classes from "./UserDevicesPage.module.css"
import DataManager from '../../hooks/DataManager';
import DevicesList from '../../components/GridList/DevicesList';
import DeviceLoadingGrid from '../../components/GridList/DeviceLoadingGrid';
import { da } from 'date-fns/locale';
import Stats2 from '../../components/UI/Stats/Stats2';
import Modal from '../../components/Modal/Modal';
import confirmation from '../../../src/assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/confirmation.png'
import check from '../../../src/assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'
import fail from '../../../src/assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/cross.png'
import loadingIcon from '../../../src/assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/loading.png'
import Button1 from '../../components/UI/Button/Button1';
import DropDownForm from '../../components/forms/DropdownCreateGroup';
import SetPhoneNumber from '../../components/Modal/ModalLayouts/SetPhoneNumber';
import UpdateUsername from '../../components/Modal/ModalLayouts/UpdateUsername';
import UpdateEmail from '../../components/Modal/ModalLayouts/UpdateEmail';
import successAnim from '../../assets/animations/success.json'
import failAnim from '../../assets/animations/fail.json'
import areYouSureAnim from '../../assets/animations/areYouSure.json'
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';

const UserDevicesPage = () => {

  const dataManager = new DataManager()

  const ModalDialog = useRef();

  const HandleShowModal = () => {
    ModalDialog.current.open();
    setChangeNotifications(false)
      setChangePortalAdmin(false)
      setChangePhoneNumber(false)
      setChangeUsername(false)
      setChangeEmailAddress(false)
  };

  const HandleCloseModal = () => {
      ModalDialog.current.close();
      setChangeNotifications(false)
      setChangePortalAdmin(false)
      setChangePhoneNumber(false)
      setChangeUsername(false)
      setChangeEmailAddress(false)
  };

  const [modalComponent, setModalComponent] = useState();
  const [modalTitle, setModalTitle] = useState();
  const navigate = useNavigate();
  const [UserDevices, setUserDevices] = useState([]);
  const [userObj, setUserObj] = useState(dataManager.getItem('clickedUserObj'))
  console.log(userObj)
  const portalAccess = userObj.portalAccess == null || userObj.portalAccess == "" || userObj.portalAccess == '' ? "No" : "Yes"
  console.log(portalAccess)
  console.log(userObj.portalAccess)
  const notifications = userObj.notifications == "yes" ? "Enabled" : "Disabled"
  const lastLoggedInDate = userObj.lastLoggedIn ? new Date(userObj.lastLoggedIn) : "Never"
  const userSinceDate = new Date(userObj.created)
  const phoneNumber = userObj.phoneNumber == '0' ? "Not provided" : userObj.phoneNumber
  const userName = userObj.fullName
  const userEmail = userObj.email
  const formattedLastLoggedIn = lastLoggedInDate.toLocaleString("en-GB", {
    day: "numeric", 
    month: "long", 
    year: "numeric",
  });
  const formattedUserSinceDate = userSinceDate.toLocaleString("en-GB", {
    day: "numeric", 
    month: "long", 
    year: "numeric",
  });
  const client = useSelector(state => state.auth.client);
  const token = useSelector(state => state.auth.token);
  let ClickedUserID = dataManager.getItem('clickedUserID')
  const companyName = useSelector(state => state.auth.companyName);
  const [update, setUpdate] = useState(0)
  const pageFetchedIndex = dataManager.getItem('pageIndex')
  const [loading, setIsLoading] = useState(true)
  const [filteredData, setFilteredData] = useState([]);
  const [changeNotifications, setChangeNotifications] = useState(false)
  const [changePortalAdmin, setChangePortalAdmin] = useState(false)
  const [changePhoneNumber, setChangePhoneNumber] = useState(false)
  const [editUserAccess, setEditUserAccess] = useState(false)
  const [sitesForGroupMode, setSitesForGroupMode] = useState(false)
  const [buttonTitle, setButtonTitle] = useState("Remove sites")
  const [addToGroupButtonTitle, setAddToGroupButtonTitle] = useState("Add sites to a group")
  const [sitesToRemove, setSitesToRemove] = useState([]);
  const [sitesForGroup, setSitesForGroup] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("")
  const myUserID = useSelector(state => state.auth.userID)
  const [groups, setGroups] = useState()
  const [selectAllCancelled, setSelectAllCancelled] = useState(false)
  const [showMassSettings, setShowMassSettings] = useState(false)
  const [changeUsername, setChangeUsername] = useState(false)
  const [changeEmailAddress, setChangeEmailAddress] = useState(false)

  const [addToGroupVisible, setAddToGroupVisible] = useState(false)
  const [successVisible, setSuccessVisible] = useState(false)
  const [failVisible, setFailVisible] = useState(false)
  const [confirmVisible, setConfirmVisible] = useState(false)

  const apiData = {
    token,
    client
  }

  let origin = null

  switch (userObj.origin){
    case "created":
      origin = `Created by ${userObj.createdByName}`
      break;
    case "invited":
      origin = `Invited by ${userObj.createdByName}`
      break;
    case "self": 
      origin = "Registered via app"
      break;
  }

  const HandleUsersDevices = async () => {
    const data = await getUsersDevices(apiData, ClickedUserID, companyName, dispatch)
    dataManager.setItem('existingSites', []);
    setFilteredData(data)
    setUserDevices(data)
    console.log(data)
    setIsLoading(false)
  }

  const GetGroups = async () => {
    const response = await getGroups(apiData, dispatch);
    setGroups(response)
  }

  const dispatch = useDispatch();


  useEffect(() => {
    GetGroups();
    HandleUsersDevices();
  }, []);


  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const handleDeviceFilter = () => {
      const filtered = UserDevices.filter((item) =>
        Object.values(item)
          .some((value) => value?.toString().toLowerCase().includes(searchQuery.toLowerCase()))
      );
      dataManager.setItem('userSitesSearchTerm', searchQuery); 
      setFilteredData(filtered); 
    };
  
    if (searchQuery !== dataManager.getItem('userSitesSearchTerm')) {
      handleDeviceFilter(); 
    }
  }, [searchQuery]);

  const HandleEditUser = async (task) => {
    switch (task){
      case 'notification' :
        //pertform change NC API
        let newState = userObj.notifications == 'yes' ? "no" : "yes"
        const responseData = await enableUserNotifications(apiData, userObj.id, newState, dispatch)
        if (responseData) {
          const newStateFormatted = newState == "yes" ? "enabled" : "disabled"
          console.log(userObj)
          setUserObj((prevUserObj) => ({
            ...prevUserObj,
            notifications: newState,
          }));
          HandleCloseModal();
          setChangeNotifications(false)
          successModal(`Successfully ${newStateFormatted} notifications for ${userObj.fullName}`)
        } else {
          HandleCloseModal();
          setChangeNotifications(false)
          errorModal(`Failed to update notifications for ${userObj.fullName}`)
        }
        
      break;
      case 'portalAdmin':
        //perform change installer API
        const newValue = userObj.portalAccess !== "" ? "" : "INSTALLER"
        const response = await switchInstallerMode(apiData, userObj.id, newValue)
        if (response) {
          const newValueFormatted = newValue == "" ? "revoked" : "granted"
            //modify userObj to update installer value
          setUserObj((prevUserObj) => ({
            ...prevUserObj,
            portalAccess: newValue,
          }));

          HandleCloseModal();
          setChangePortalAdmin(false)
          successModal(`Successfully ${newValueFormatted} app admin privilages for ${userObj.fullName}`)
        } else {
          HandleCloseModal()
          setChangePortalAdmin(false)
          errorModal(`Failed to update app admin privilages for ${userObj.fullName}`)
        }
        
      break;
    }
  }

  const confirmModal = (message, task) => {
      setModalTitle("Confirm")
      setModalComponent(
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <img className={classes.ModalIcon} src={confirmation}>
          </img>
          <br></br>
          <br></br>
          <div>
              <h3 style={{ textAlign: "center", color:"#858585"}}>{message}</h3>
          </div>   
          <br></br>
          <br></br>
          <div>
            <br></br>
            <Button1 onClick={() => HandleEditUser(task)} style={{width:"100%"}}>Confirm</Button1>
            <br></br>
            <Button1 onClick={HandleCloseModal} style={{width:"100%"}}>Cancel</Button1>
          </div>
        </div>
      )
      HandleShowModal();
  }

  const successModal = (message) => {
    setModalTitle('Success')
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <img className={classes.ModalIcon} src={check}>
        </img>
        <br></br>
        <br></br>
        <div>
            <h3 style={{ textAlign: "center", color:"#858585"}}>{message}</h3>
        </div>   
        <br></br>
        <br></br>
        <div>
          <Button1 onClick={HandleCloseModal} style={{width:"100%"}}>Close</Button1>
        </div>
      </div>
    )
    HandleShowModal();
  }

  const errorModal = (message) => {
    setModalTitle('Error')
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <img className={classes.ModalIcon} src={fail}>
        </img>
        <br></br>
        <br></br>
        <div>
            <h3 style={{ textAlign: "center", color:"#858585"}}>{message}</h3>
        </div>   
        <br></br>
        <br></br>
        <div>
          <Button1 onClick={HandleCloseModal} style={{width:"100%"}}>Close</Button1>
        </div>
      </div>
    )
    HandleShowModal();
  }

  useEffect(() => {
    if (changeNotifications){
      const newValue = userObj.notifications == 'no' ? "enable" : "disable"
      confirmModal(`Are you sure you want to ${newValue} notifications for ${userObj.fullName}?`, "notification");
    }
    
  }, [changeNotifications])

  useEffect(() => {
    console.log(changePortalAdmin)
    if (changePortalAdmin){
      //TODO - Bug here, needs 2 presses
      const newValue = userObj.portalAccess !== "" && userObj.portalAccess !== null ? "revoke" : "grant"
      confirmModal(`Are you sure you want to ${newValue} app admin privilages for ${userObj.fullName}?`, "portalAdmin");
    }
  }, [changePortalAdmin])

  useEffect(() => {
    console.log("here")
    if (changePhoneNumber){
      //showpopup
      setModalTitle("Edit phone number")
      setModalComponent(
        <SetPhoneNumber 
          placeholder={phoneNumber}
          successModal={successModal}
          errorModal={errorModal}
          HandleCloseModal={HandleCloseModal}
          HandleShowModal={HandleShowModal}
          userObject={userObj}
          setUserObject={setUserObj}
        />
      )

      HandleShowModal();
    }
    
  }, [changePhoneNumber])


  useEffect(() => {
    if (changeUsername) {
      setModalTitle("Change name")
      setModalComponent(
        <UpdateUsername
          placeholder={userName}
          successModal={successModal}
          errorModal={errorModal}
          HandleCloseModal={HandleCloseModal}
          HandleShowModal={HandleShowModal}
          userObject={userObj}
          setUserObject={setUserObj}
        />
      )
      HandleShowModal();
    }
  }, [changeUsername])


  useEffect(() => {
    if (changeEmailAddress) {
      setModalTitle("Change email address")
      setModalComponent(
        <UpdateEmail
          placeholder={userEmail}
          successModal={successModal}
          errorModal={errorModal}
          HandleCloseModal={HandleCloseModal}
          HandleShowModal={HandleShowModal}
          userObject={userObj}
          setUserObject={setUserObj}
        />
      )
      HandleShowModal();
    }
  }, [changeEmailAddress])

  useEffect(() => {
    console.log(sitesToRemove)
  }, [sitesToRemove])

  useEffect(() => {
    console.log(sitesForGroup)
  }, [sitesForGroup])
  
  const editUserSiteAccess = () => {
    setButtonTitle(!editUserAccess ? "Cancel" : "Remove sites")
    setEditUserAccess(!editUserAccess);

    if (buttonTitle == "Cancel"){
      setSitesToRemove([])
      dataManager.setItem('existingSites', [])
      setSelectAllCancelled(true)
    }
  }

  const HandleRevokeAccess = async () => {
    pleaseWaitModal(sitesToRemove.length);
    if (sitesToRemove.length > 0){
      for (const site of sitesToRemove) {
        const { deviceUUID, deviceID } = site;
        const success = await removeUser(apiData, deviceID, deviceUUID, myUserID, userObj.id, dispatch);
    
        if (success) {
          setFilteredData(prevFilteredData => prevFilteredData.filter(site => site.deviceUUID !== deviceUUID));
          console.log(`Successfully removed site with UUID: ${deviceUUID}`);
        } else {
          console.log(`Failed to remove site with UUID: ${deviceUUID}`);
        }
      }
      HandleCloseModal();
      setEditUserAccess(false)
      setButtonTitle("Remove sites")
      successModal(`${userObj.fullName}'s access successfully revoked from ${sitesToRemove.length} site(s)`)
      HandleUsersDevices()
      setSitesToRemove([])
    } else {
      errorModal("Please select a site")
    }
  }

  const HandleGiveAccess = () => {
    //dataManager.setItem('isGroupMode', true);
    dataManager.setItem('isAddAccessMode', true)
    dataManager.setItem('existingSites', UserDevices)
    console.log(UserDevices)
    navigate('/Dashboard/AllSites/');
  }

  const pleaseWaitModal= (siteCount) => {
    setModalTitle("Please wait")
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <img className={classes.ModalIcon} src={loadingIcon}>
        </img>
        <br></br>
        <br></br>
        <div>
            <h3 style={{ textAlign: "center", color:"#858585"}}>{`Revoking ${userObj.fullName}'s access from ${siteCount} site(s)`}</h3>
        </div>   
        <br></br>
        <br></br>
      </div>
    )
    HandleShowModal();
  }

  const waitModal= (siteCount, groupName) => {
    setModalTitle("Please wait")
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <img className={classes.ModalIcon} src={loadingIcon}>
        </img>
        <br></br>
        <br></br>
        <div>
            <h3 style={{ textAlign: "center", color:"#858585"}}>{`Adding ${siteCount} sites to ${groupName}`}</h3>
        </div>   
        <br></br>
        <br></br>
      </div>
    )
    HandleShowModal();
  }


  const HandleAddSitesForGroup = () => {
    setAddToGroupButtonTitle(!sitesForGroupMode ? "Cancel" : "Add sites to a group")
    setSitesForGroupMode(!sitesForGroupMode);

    if (addToGroupButtonTitle == "Cancel"){
      setSitesForGroup([])
      setSelectAllCancelled(true)
    }
  }

  const ShowSelectGroup = async () => {
    if (sitesForGroup.length > 0){
      const allGroups = await getGroups(apiData, dispatch);
      const groupNames = allGroups.map(listOptions => listOptions.name).sort((a, b) => a.localeCompare(b));;
      console.log(groupNames)
          setModalTitle("Add site to group")
          setModalComponent(
            <div>
              <DropDownForm label={"Please select a group below"} dropDownOptions={groupNames} setSelectedGroup={setSelectedGroup} />
              <br></br>
              <Button1 onClick={() => AddSitesToGroup(allGroups)}>Add to group</Button1>
            </div>
            
          )
          HandleShowModal();
    } else {
      errorModal("Please select a site")
    }
  }

  const AddSitesToGroup = async () => {
    if (sitesForGroup.length > 0) {

      let body = {
        groupID: selectedGroup.id,
        groupName: selectedGroup.name,
        groupDevices: sitesForGroup,
      }

      const response = await addSitesToGroup(apiData, body, dispatch)
      if (response.success){
        //HandleCloseModal();
        setAddToGroupVisible(false)
        waitModal(sitesForGroup.length, dataManager.getItem('selectedGroup'))
        successModal(`${sitesForGroup.length} sites successfully added to ${selectedGroup.name}`, false);
        setSitesForGroupMode(false)
        setSitesForGroup([])
        setAddToGroupButtonTitle("Add sites to a group")
        HandleUsersDevices()
      } else {
        console.log("failed")
      }
    } else {
      errorModal("Please select a site");
    }
  }


  return (  
    <>
    <Modal ref={ModalDialog} title={modalTitle} modalName={""} HandleShowModal={HandleShowModal}>
          {modalComponent}
    </Modal>

    <Dialog
        header="Add to group"
        visible={addToGroupVisible}
        style={{ width: "40vw" }}
        onHide={() => setAddToGroupVisible(false)}
        >
        <div>
            <p>Choose the new group from the dropdown below</p>
            <Dropdown
                value={selectedGroup}
                className="w-full md:w-14rem"
                style={{ width: '400px' }}
                onChange={(e) => setSelectedGroup(e.value)}
                options={groups}
                optionLabel="name"
                placeholder="Choose group"
                showClear
                filter
                filterPlaceholder="Search groups..."
            />


        </div>

        <br></br>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button label="Add sites to group" severity="success" icon="pi pi-plus" disabled={!selectedGroup} onClick={AddSitesToGroup} />
        </div>
    </Dialog>
    
    
    <Await resolve={filteredData}>
      {(loadedUserDevices) => {
        return (
          <>
          <div className={classes.container}>
            <Stats2 title={"Name"} value={userObj.fullName}  isLoadingStats={false} isStatic={true} setChangeUsername={setChangeUsername} editable={true}/>
            <Stats2 title={"Email address"} value={userObj.email}  isLoadingStats={false} isStatic={true} setChangeEmailAddress={setChangeEmailAddress} editable={true}/>
            <Stats2 title={"Phone number"} value={phoneNumber}  isLoadingStats={false} isStatic={true} setChangePhoneNumber={setChangePhoneNumber} editable={true}/>
            <Stats2 title={"User since"} value={formattedUserSinceDate}  isLoadingStats={false} isStatic={true} /> 
            <Stats2 title={"Last logged in"} value={formattedLastLoggedIn}  isLoadingStats={false} isStatic={true} /> 
            {userObj.type && <Stats2 title={"Device type"} value={userObj.type}  isLoadingStats={false} isStatic={true} />}
            { origin && <Stats2 title={"Origin"} value={origin}  isLoadingStats={false} isStatic={true} /> }
            <Stats2 title={"Total access"} value={filteredData.length}  isLoadingStats={false} isStatic={true} /> 
            <Stats2 title={"Notifications"} value={notifications}  isLoadingStats={false} isStatic={true} changeNotifications={changeNotifications} setChangeNotifications={setChangeNotifications} editable={true}/>
            <Stats2 title={"App admin"} value={portalAccess}  isLoadingStats={false} isStatic={true} changePortalAdmin={changePortalAdmin} setChangePortalAdmin={setChangePortalAdmin} editable={true}/>
          </div>
          
            <div style={{ width: "100%", minWidth: "500px", height: "100%", minHeight:"500px" }} >
              {loading ? (
                  <div style={{ display: "flex", width: "100%" }}>
                      <DeviceLoadingGrid
                      CardCount={
                          20
                      }
                      />
                  </div>
                ) : (
                <div style={{width: "100%"}}>
                  <div className={classes.searchContainer}>
                    <SearchBar
                      type="text"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{
                        padding: "10px", // Adjust padding to reduce height
                        width: "200px", // Set a specific width
                        fontSize: "14px", // Adjust font size for better proportions
                        boxSizing: "border-box", // Ensure consistent sizing
                        borderRadius: "4px", // Add slight rounding for aesthetics
                      }}
                      
                    />
                   
                    

                    {/* Buttons wrapper */}
                    <div style={{ display: "flex", gap: "10px", marginLeft:"20px" }}>

                    { (!sitesForGroupMode && !editUserAccess)&& (<Button
                        label='Add sites'
                        icon="pi pi-plus"
                        severity='success'
                        style={{padding:10, fontSize:"14px"}}
                        onClick={HandleGiveAccess}
                        >
                        
                      </Button>)}

                      { !sitesForGroupMode && (<Button
                        label={buttonTitle}
                        icon="pi pi-times"
                        severity='danger'
                        style={{padding:10, fontSize:"14px"}}
                        onClick={editUserSiteAccess}
                      >
                        
                      </Button>)}

                      {!editUserAccess && ( <Button
                      label={addToGroupButtonTitle}
                      icon={addToGroupButtonTitle == "Cancel" ? "pi pi-times" : "pi pi-plus"}
                      severity={addToGroupButtonTitle == "Cancel" ? 'danger': 'info'}
                      style={{padding:10, fontSize:"14px"}}
                      onClick={HandleAddSitesForGroup}
                      >
                       
                      </Button> )}

                    {(!editUserAccess && sitesForGroupMode)&& ( <Button
                      label='Add to group'
                      icon="pi pi-plus"
                      severity='success'
                      style={{padding:10, fontSize:"14px"}}
                      onClick={() => setAddToGroupVisible(true)}>
                        
                      </Button> )}

                    {(editUserAccess && !sitesForGroupMode)&& 
                      <Button
                      label='Revoke access'
                      icon="pi pi-ban"
                      severity='danger'
                      style={{padding:10, fontSize:"14px"}}
                      onClick={() => HandleRevokeAccess()}
                      >
                      
                      </Button>}

                     

                      

                      
                    </div>

                    
                  </div>

                  {searchQuery !== "" && (
                      <div>
                        <p>{filteredData.length} results</p>
                      </div>
                    )}

                  <DevicesList 
                    devices={loadedUserDevices}
                    filtering={""}
                    pageFetchedIndex={1}
                    isUsersSites={true}
                    groupMode={false}
                    update={update}
                    setUpdate={setUpdate}
                    hideControls={true}
                    isSortable={true}
                    editUserAccess={editUserAccess}
                    sitesForGroup={sitesForGroup}
                    setSitesForGroup={setSitesForGroup}
                    sitesForGroupMode={sitesForGroupMode}
                    setSitesForGroupMode={setSitesForGroupMode}
                    sitesToRemove={sitesToRemove}
                    setSitesToRemove={setSitesToRemove}
                    HandleGiveAccess={HandleGiveAccess}
                    selectAllCancelled={selectAllCancelled}
                    showMassSelect={false}
                    showMassSettings={showMassSettings}
                    setShowMassSettings={setShowMassSettings}
                  />
                  </div>
                )
              }
            </div>
        </>
        )
      }
    } 
  </Await>
  </>
  )
}

export default UserDevicesPage

export async function loader() {
  const token = localStorage.getItem('token');
  const client = localStorage.getItem('client');
  const companyName = localStorage.getItem('companyName');
  const userID = localStorage.getItem('ClickedUserID');

  const apiData = {
    token,
    client
  }

  return defer({
    //userDevices: getUsersDevices(apiData, userID, companyName)
  })
}
